export const IRB_FLAGS = {
    irbDisableRealAppScreens: {
        id: 'irbDisableRealAppScreens',
        value: false,
        name: 'Disable real app screens',
        description: 'Disable the inclusion of real app screens in the submission package report',
        owner: 'Translation Workbench',
        extra: { section: 'IRB', dataTestId: 'irb-disable-real-app-screens-flag' },
    },
    irbEnableLenientRealAppScreens: {
        id: 'irbEnableLenientRealAppScreens',
        value: false,
        name: 'Lenient real app screens inclusion',
        description: 'Include real app screens even when some conditions or validations fail',
        owner: 'Translation Workbench',
        extra: { section: 'IRB', dataTestId: 'irb-lenient-real-app-screens-flag' },
    },
};
